import { FC } from 'react';
import { DetailFieldProps } from './harmReports.type';

export const DetailField: FC<DetailFieldProps> = (props) => {
  const formatValue = (
    value: string | number | boolean | Date | undefined,
  ): string => {
    if (value instanceof Date) {
      return value.toLocaleDateString();
    }
    if (!value) {
      return '-';
    }
    return String(value);
  };

  const style = props.flexBasis ? { flexBasis: props.flexBasis } : {};

  return (
    <div className={`flex flex-col ${props.className || ''}`} style={style}>
      <span className="text-[#7C7AA8] text-xs">{props.label}</span>
      <span className="text-[#151740] text-xs font-medium">
        {formatValue(props.value)}
      </span>
    </div>
  );
};
